module.exports = __webpack_public_path__ + "img/ez-slot-category-skill-game-mobile.88f3ddde.png";